import styled from "@emotion/styled";
import bgImage from "../../assets/bgImage.png";

const EmployeeCompanyPolicyStyle = styled.div({
  position: "relative",
  background: `url(${bgImage})`,
  objectFit: "cover",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "fixed",
  backgroundPosition: "center center",
});

export default EmployeeCompanyPolicyStyle;
